module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', [_h('router-view')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39e8e164!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 24
// module chunks = 1